module.exports = __webpack_public_path__ + "img/DE00741.c51b8e3b.png";